import { Autocomplete, TextField, useMediaQuery } from '@mui/material';
import React from 'react';
import { useChallengeContextContext } from 'context/ChallengeContext/ChallengeContext';
import { EditorProps } from 'react-data-grid';
import EmptyCell from 'components/EmptyCell';

export function OneRmAutoCompleteComponent<TRow, TSummaryRow>({
  row,
  column,
  onRowChange,
  onClose,
}: EditorProps<TRow, TSummaryRow>) {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const { conditions } = useChallengeContextContext();

  const onChangeValue = (value: IChallengeConditions) => {
    onRowChange({ ...row, [column.key]: value }, true);
    onClose();
  };

  if ((row as any).name === 'isRest') {
    return <EmptyCell />;
  }

  return (
    <Autocomplete
      autoSelect
      autoHighlight
      getOptionLabel={(option) => option.name}
      // value={row[column.key as keyof TRow] as unknown as string}
      sx={{ width: '100%', flex: 1 }}
      freeSolo
      options={[...new Set(conditions)]}
      onChange={(_, value) => onChangeValue(value as IChallengeConditions)}
      renderInput={(params) => (
        <TextField
          sx={{ input: { color: prefersDarkMode ? 'white' : 'black' } }}
          autoFocus
          {...params}
          size='small'
          type='text'
          placeholder='1RM 기준 운동명'
        />
      )}
    />
  );
}
